import styles from './SlotLoversSection.module.css';
import { Image, Text } from '@betty/moonlight';

function SlotLoversSection() {
  return (
    <div className={styles.slotLoversSection}>
      <Image
        name="landingPage.leafsLogo"
        width={{
          desktop: 48,
          tablet: 48,
          mobile: 40,
        }}
        height={{
          desktop: 48,
          tablet: 48,
          mobile: 40,
        }}
        objectFit='contain'
      />
      <div className={styles.slotLoversTitle}>
        <Text variant="callout" gradient="darkSurfaceAccent">
          An Official Online Casino Partner
        </Text>
      </div>
      <Image
        name="landingPage.ball"
        objectFit='contain'
        width={{
          desktop: 48,
          tablet: 48,
          mobile: 40,
        }}
        height={{
          desktop: 48,
          tablet: 48,
          mobile: 40,
        }}
      />
    </div>
  );
}

export default SlotLoversSection;
